import {ActiveCall} from '@/redux/commonCalls/types';

export const getUserName = (callData: ActiveCall) => {
    const {patientFullName = '', firstName = '', lastName = ''} = callData || {};
    const userNameFromParts =
        firstName || lastName ? `${lastName}${lastName && firstName ? ', ' : ''}${firstName} ` : null;

    return patientFullName || userNameFromParts || 'Unknown';
};
